// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sb-media_wrapper__wiUKY","desktop":"sb-media_desktop__8g2Zc","mobile":"sb-media_mobile__Xeb4K"};